// Verified Google sign-in (Founder-authorized Oct 25): web uses Google Identity Services, the iOS/Android app uses
// native Google sign-in. Both hand a Google ID token to the server, which verifies it.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import React from 'react';
import { Capacitor } from '@capacitor/core';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

const WEB_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const IOS_CLIENT_ID = process.env.REACT_APP_GOOGLE_IOS_CLIENT_ID;

export const nativeGoogleCredential = async () => {
  const { SocialLogin } = await import('@capgo/capacitor-social-login');
  await SocialLogin.initialize({
    google: { webClientId: WEB_CLIENT_ID, iOSClientId: IOS_CLIENT_ID, iOSServerClientId: WEB_CLIENT_ID, mode: 'online' },
  });
  const res = await SocialLogin.login({ provider: 'google', options: { scopes: ['email', 'profile'] } });
  return res?.result?.idToken || null;
};

export const GoogleCredentialButton = ({ onCredential, onError, text = 'continue_with', testId, lang, renderNative }) => {
  if (!WEB_CLIENT_ID) {
    return (
      <p data-testid={`${testId}-unavailable`} style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', textAlign: 'center' }}>
        {lang === 'es' ? 'El inicio de sesión con Google no está disponible ahora mismo.' : "Google sign-in isn't available right now."}
      </p>
    );
  }
  if (Capacitor.isNativePlatform()) {
    return renderNative(async () => {
      try {
        const credential = await nativeGoogleCredential();
        if (credential) onCredential(credential); else onError?.();
      } catch (e) {
        onError?.(e);
      }
    });
  }
  return (
    <GoogleOAuthProvider clientId={WEB_CLIENT_ID}>
      <div data-testid={testId} className="w-full flex justify-center">
        <GoogleLogin
          onSuccess={(r) => (r?.credential ? onCredential(r.credential) : onError?.())}
          onError={() => onError?.()}
          theme="filled_black"
          shape="pill"
          text={text}
          locale={lang === 'es' ? 'es' : 'en'}
          width="320"
        />
      </div>
    </GoogleOAuthProvider>
  );
};
